// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactBanner_contact__160EF","dark":"ContactBanner_dark__sVnWo"};